import desktopNavJS from './main-nav-helper/main-nav-helper-desktop';
import mobileNavJS from './main-nav-helper/main-nav-helper-mobile';
import destinationMobileMenu from './destinations-mobile';
import destinationMainMenu from './destinations-desktop-mainMenu';
import debounce from 'lodash.debounce';

let currentMode = null;

function mainNavHelper() {
  function loadNavHelper() {
    const windowWidth = window.innerWidth;

    if (windowWidth <= 1024 && currentMode !== 'mobile') {
      currentMode = 'mobile';
      mobileNavJS();
      destinationMobileMenu();
    } else if (windowWidth > 1024 && currentMode !== 'desktop') {
      currentMode = 'desktop';
      desktopNavJS();
    }

    destinationMainMenu();
  }

  loadNavHelper();
  window.addEventListener('resize', debounce(loadNavHelper, 100));
}

export default mainNavHelper;
